import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const heroPadding = {
    paddingTop: isMobile ? '100px' : '100px',
    paddingBottom: isMobile ? '30px' : '40px'
  };

  const bannerHeight = {
    minHeight: isMobile ? '60vh' : 'calc(100vh - 90px)'
  };

  return (
    <>
      {/* Hero Banner Section */}
      <div className="header-banner bg-theme-dark">
        <div className="nk-banner">
          <div className="banner banner-mask-fix banner-fs banner-single tc-light" style={{ position: 'relative', ...bannerHeight }}>
            <div className="nk-circle-pk" style={{ position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%) scale(0.75)', zIndex: 0 }}>
              <div className="line-1"></div>
              <div className="line-2"></div>
              <div className="line-3"></div>
              <div className="line-4"></div>
            </div>
            <div className="nk-circle-pk" style={{ position: 'absolute', top: '60%', left: '15%', transform: 'translate(-50%, -50%) scale(0.6)', zIndex: 0 }}>
              <div className="line-1"></div>
              <div className="line-2"></div>
              <div className="line-3"></div>
              <div className="line-4"></div>
            </div>
            <div className="nk-circle-pk" style={{ position: 'absolute', top: '60%', left: '85%', transform: 'translate(-50%, -50%) scale(0.6)', zIndex: 0 }}>
              <div className="line-1"></div>
              <div className="line-2"></div>
              <div className="line-3"></div>
              <div className="line-4"></div>
            </div>
            <div className="banner-wrap ov-v" style={{ position: 'relative', zIndex: 1 }}>
              <div className="container" style={heroPadding}>
                <div className="row align-items-center justify-content-center gutter-vr-30px">
                  <div className="col-lg-8">
                    <div className="banner-caption wide-auto text-center">
                      <div className="cpn-head mt-0">
                        <h6 className="title-sub mb-4" style={{ fontWeight: 'normal', color: '#ffd700', fontSize: '16px' }}>AI-Powered Solutions</h6>
                        <h1 className="title title-xl-2" style={{ marginTop: '20px' }}>Empowering Barangays Through <br />Digital Governance</h1>
                      </div>
                      <div className="cpn-text cpn-text-s1">
                        <p className="lead" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                          A cloud-based and secured digital platform designed to modernize barangay operations
                        </p>
                      </div>
                      <div className="cpn-btns">
                        <ul className="btn-grp justify-content-center">
                          <li>
                            <a
                              href="https://play.google.com/store"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-md btn-grad btn-round"
                            >
                              Download App
                            </a>
                          </li>
                          <li>
                            <Link to="/services" className="btn btn-md btn-grad btn-grad-alternet btn-round">
                              Explore Services
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="nk-ovm mask-c-dark shape-v mask-contain-bottom"></div>
        {/* Particle Js */}
        <div
          id="particles-bg"
          className="particles-container particles-bg"
          data-pt-base="#00c0fa"
          data-pt-base-op=".3"
          data-pt-line="#2b56f5"
          data-pt-line-op=".5"
          data-pt-shape="#00c0fa"
          data-pt-shape-op=".2"
        ></div>
      </div>

      {/* Key Features Section */}
      <section className="section bg-white" style={{ paddingTop: '30px', paddingBottom: '80px' }}>
        <div className="container">
          <div className="section-head text-center wide-auto-sm" style={{ paddingBottom: '5px', marginBottom: '30px' }}>
            <h2 className="title title-s4" style={{ marginBottom: '0' }}>Key Features</h2>
            <p style={{ marginTop: '-15px', marginBottom: '0' }}>
              Powerful tools designed to transform barangay governance
            </p>
          </div>

          <div className="nk-block">
            <div className="row gutter-vr-40px justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ border: '2px solid #e02f29', height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-laptop"></em>
                  </div>
                  <h4 className="title title-sm mb-3">EBARANGAY Desktop</h4>
                  <p>
                    Comprehensive Windows desktop application for barangay officials. Manage records, process
                    documents, generate reports, and oversee all barangay operations from a centralized system.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ border: '2px solid #e02f29', height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-mobile-alt"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Mobile App</h4>
                  <p>
                    Access barangay services anytime, anywhere through our mobile application. Submit requests, track
                    applications, and receive notifications directly on your smartphone.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ border: '2px solid #e02f29', height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-video"></em>
                  </div>
                  <h4 className="title title-sm mb-3">AI-Powered Surveillance</h4>
                  <p>
                    Real-time surveillance feature monitoring public areas using smart cameras to detect crowds,
                    vehicles, and plate numbers. AI-powered technology enhancing safety and response efficiency for
                    the community.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ border: '2px solid #e02f29', height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-map-marker-alt"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Tanod GPS Tracking</h4>
                  <p>
                    Real-time GPS tracking system displaying each tanod's live location on a map. Monitor patrol
                    coverage, ensure safety visibility, and respond quickly to incidents across the barangay.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ border: '2px solid #e02f29', height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-id-card"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Barangay Digital ID</h4>
                  <p>
                    Secure digital identification system for all barangay residents. Unique digital IDs enable quick
                    verification, seamless access to services, and secure authentication for all barangay transactions
                    and records with enhanced data protection.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ border: '2px solid #e02f29', height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-link"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Blockchain Technology</h4>
                  <p>
                    Secure and transparent record-keeping using blockchain technology. Immutable data storage ensures
                    integrity of barangay records, certificates, and transactions with tamper-proof verification.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Barangay Services Section */}
      <section className="section bg-light" style={{ paddingTop: '30px' }}>
        <div className="container">
          <div className="section-head text-center wide-auto-sm" style={{ paddingBottom: '5px', marginBottom: '30px' }}>
            <h2 className="title title-s4" style={{ marginBottom: '0' }}>Barangay Services</h2>
            <p style={{ marginTop: '-15px', marginBottom: '0' }}>
              Comprehensive digital services for efficient barangay management
            </p>
          </div>

          <div className="nk-block">
            <div className="row gutter-vr-40px justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-certificate"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Barangay Clearances</h4>
                  <p>
                    Issuance of barangay clearance, certificate of indigency, or certificate of residency for residents' official transactions.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-store"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Business Permits</h4>
                  <p>
                    Application and renewal of barangay business permits for local establishments and entrepreneurs.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-book"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Blotters</h4>
                  <p>
                    Recording of incidents, complaints, or community disputes reported to the barangay for documentation and resolution.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-exclamation-circle"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Complaints</h4>
                  <p>
                    Formal filing of grievances or issues by residents for mediation and barangay action.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-calendar-check"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Special Permits</h4>
                  <p>
                    Application for special event or activity permits within the barangay (e.g., public gatherings, fiestas, or road closures).
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card text-center" style={{ height: '100%', minHeight: '260px' }}>
                  <div className="service-icon mx-auto">
                    <em className="fas fa-paw"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Pet Registrations</h4>
                  <p>
                    Registration of household pets for barangay records, vaccination monitoring, and issuance of pet identification.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section bg-theme tc-light">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="title title-lg mb-3">Ready to Transform Your Barangay?</h2>
              <p className="lead mb-4">
                Explore our services and learn how EBARANGAY can modernize your barangay operations.
              </p>
              <ul className="btn-grp justify-content-center">
                <li>
                  <Link to="/services" className="btn btn-lg btn-grad btn-grad-alternet btn-round">
                    View Services
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="btn btn-lg btn-outline btn-white btn-round">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
